import React, { useContext } from "react";
import { Box, Switch, FormGroup, FormControlLabel } from "@mui/material";
import { ThemeModeContext } from '../shared/Theme.jsx';
import { contentBoxStyle } from "../shared/Theme";
import Sidebar from "../elements/Sidebar";
import Header from "../elements/Header";

const Settings = () => {
	
	const themeModeContext = useContext(ThemeModeContext);
	
	const handleDarkModeSwitch = (event) => {
		const mode = (event.target.checked)? "dark" : "light";
		themeModeContext.setThemeMode(mode);
	};
	
	return (
		<Box sx={{ display: "flex" }}>
			<Sidebar/>
			<Box component="main" sx={{flexGrow: 1, bgcolor: "background.default"}}>
				<Header pageTitle="Settings"/>
				<Box sx={contentBoxStyle}>
					<FormGroup>
						<FormControlLabel
							control={
								<Switch
									checked={themeModeContext.themeMode !== "light"}
									onChange={handleDarkModeSwitch}
								/>
							}
							label="Dark Mode"
						/>
					</FormGroup>
				</Box>
			</Box>
		</Box>
	);
}

export default Settings;
